import Gumshoe from 'gumshoejs'
import SubnavBarAutoScrollerController from './subnav-bar-auto-scroller-controller'

export default class SubnavBarController {
  constructor (element) {
    this._element = element
    this._bindUIActions()
    this._subnavBarAutoScrollerController = new SubnavBarAutoScrollerController(element)
  }

  _bindUIActions () {
    const listElement = this._element.querySelector('.subnav-bar__menu__list')
    console.log('listElement', listElement)
    if (listElement) {
      const gumshoe = new Gumshoe('.subnav-bar__menu__link', {
        navClass: 'subnav-bar__menu__item--active',
        contentClass: 'press__item--active'
      })
      // Listen for activate events
      listElement.addEventListener('gumshoeActivate', event => {
        // The list item
        // var li = event.target

        //   // The link
        //   var link = event.detail.link

        //   // The content
        //   var content = event.detail.content

        this._subnavBarAutoScrollerController.notifyChange()
      }, false)
    }
  }
}
